const css = `.p-dialog.bulk-cancel-dialog {
  width: 90vw;
  max-width: 800px;
}
.p-dialog.bulk-cancel-dialog .p-dialog-title {
  min-width: 0;
}
.p-dialog.bulk-cancel-dialog .bulk-cancel-heading {
  display: flex;
  flex-direction: column;
  gap: 8px;
  line-height: var(--line-height-tight);
  overflow-wrap: anywhere;
}
.p-dialog.bulk-cancel-dialog .bulk-cancel-client {
  color: var(--text-color-secondary);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-regular);
}
.p-dialog.bulk-cancel-dialog .bulk-cancel-layout {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.p-dialog.bulk-cancel-dialog .cancellation-info {
  display: flex;
  margin-bottom: 0;
  padding: 12px 16px;
  flex-direction: row;
  align-items: flex-start;
  text-align: left;
  gap: 12px;
  border-radius: 6px;
  font-size: var(--font-size-sm);
  line-height: var(--line-height-normal);
  background-color: var(--warning-subtle);
  border: 1px solid var(--warning);
}
.p-dialog.bulk-cancel-dialog .cancellation-info p {
  margin: 0;
  color: var(--warning);
}
.p-dialog.bulk-cancel-dialog .cancellation-info .warning-title {
  font-weight: var(--font-weight-semibold);
}
.p-dialog.bulk-cancel-dialog .cancellation-info p + p {
  margin-top: 4px;
}
.p-dialog.bulk-cancel-dialog .cancellation-info .warning-icon {
  color: var(--warning);
  font-size: var(--font-size-xl);
  margin-bottom: 0;
  margin-top: 2px;
  flex-shrink: 0;
}
.p-dialog.bulk-cancel-dialog .cancellation-form {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  align-items: start;
  gap: 16px;
  padding: 0;
}
.p-dialog.bulk-cancel-dialog .cancellation-form .form-field {
  min-width: 0;
  width: 100%;
  margin-bottom: 0;
}
.p-dialog.bulk-cancel-dialog .cancellation-form .form-field .p-dropdown,
.p-dialog.bulk-cancel-dialog .cancellation-form .form-field .p-inputtextarea {
  width: 100%;
}
.p-dialog.bulk-cancel-dialog .cancellation-form .bulk-cancel-custom-reason {
  grid-column: 1/-1;
}
.p-dialog.bulk-cancel-dialog .cancellation-form textarea#bulk-cancel-reason {
  padding: 12px;
  min-height: 48px;
  max-height: none;
}
.p-dialog.bulk-cancel-dialog .cancellation-form textarea {
  max-height: 300px;
  resize: vertical;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  overflow-x: hidden;
}
.p-dialog.bulk-cancel-dialog .bulk-cancel-list {
  border: 1px solid var(--surface-200);
  border-radius: 6px;
}
.p-dialog.bulk-cancel-dialog .bulk-cancel-list ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.p-dialog.bulk-cancel-dialog .bulk-cancel-list li {
  border-top: 1px solid var(--surface-200);
}
.p-dialog.bulk-cancel-dialog .bulk-cancel-list li.selected {
  background-color: var(--surface-50);
}
.p-dialog.bulk-cancel-dialog .bulk-cancel-list li:last-child {
  border-radius: 0 0 6px 6px;
}
.p-dialog.bulk-cancel-dialog .bulk-cancel-list li:hover {
  background-color: var(--surface-100);
}
.p-dialog.bulk-cancel-dialog .bulk-cancel-list li:focus-within {
  box-shadow: inset 3px 0 0 var(--primary-color);
}
.p-dialog.bulk-cancel-dialog .bulk-cancel-list li label {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  cursor: pointer;
}
.p-dialog.bulk-cancel-dialog .bulk-cancel-list li label > .p-checkbox {
  flex-shrink: 0;
}
.p-dialog.bulk-cancel-dialog .bulk-cancel-list li strong {
  display: block;
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-normal);
}
.p-dialog.bulk-cancel-dialog .bulk-cancel-list li small {
  display: block;
  margin-top: 4px;
  color: var(--text-color-secondary);
  line-height: var(--line-height-normal);
}
.p-dialog.bulk-cancel-dialog .bulk-cancel-list-header {
  position: sticky;
  top: -12px;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 48px;
  padding: 0 16px;
  background-color: var(--surface-0);
  border-radius: 6px 6px 0 0;
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-xs);
}
.p-dialog.bulk-cancel-dialog .bulk-cancel-select-all {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
}
.p-dialog.bulk-cancel-dialog .bulk-cancel-count {
  flex-shrink: 0;
  padding: 4px 8px;
  border-radius: 4px;
  background-color: var(--surface-100);
  font-size: var(--font-size-xs);
  font-variant-numeric: tabular-nums;
  font-weight: var(--font-weight-semibold);
  color: var(--text-color-secondary);
}
.p-dialog.bulk-cancel-dialog .bulk-cancel-date {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 44px;
  min-height: 52px;
  flex-shrink: 0;
  border: 1px solid var(--surface-200);
  border-radius: 4px;
  background-color: var(--surface-0);
}
.p-dialog.bulk-cancel-dialog .bulk-cancel-date > span {
  font-size: var(--font-size-2xs);
  font-weight: var(--font-weight-semibold);
  text-transform: uppercase;
  color: var(--text-color-secondary);
}
.p-dialog.bulk-cancel-dialog .bulk-cancel-date strong {
  font-size: var(--font-size-xl);
  font-variant-numeric: tabular-nums;
}
.p-dialog.bulk-cancel-dialog .bulk-cancel-reservation {
  min-width: 0;
  overflow-wrap: anywhere;
}
.p-dialog.bulk-cancel-dialog .bulk-cancel-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 12px;
  margin-top: 4px;
  font-size: var(--font-size-xs);
  line-height: var(--line-height-normal);
  color: var(--text-color-secondary);
}
.p-dialog.bulk-cancel-dialog .bulk-cancel-meta i {
  font-size: var(--font-size-xs);
}
.p-dialog.bulk-cancel-dialog .bulk-cancel-skeleton-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 16px;
  border-top: 1px solid var(--surface-200);
}
.p-dialog.bulk-cancel-dialog .bulk-cancel-skeleton-row > div {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.p-dialog.bulk-cancel-dialog .bulk-cancel-empty {
  margin: 0;
  padding: 32px 16px;
  text-align: center;
  border-top: 1px solid var(--surface-200);
  color: var(--text-color-secondary);
}
.p-dialog.bulk-cancel-dialog .bulk-cancel-empty i {
  display: block;
  margin-bottom: 12px;
  font-size: var(--font-size-3xl);
  color: var(--text-color-secondary);
}
.p-dialog.bulk-cancel-dialog .bulk-cancel-empty p {
  margin: 0;
}
@media (max-width: 768px) {
  .p-dialog.bulk-cancel-dialog {
    width: 100vw;
    max-width: 100vw;
    height: 100vh;
    max-height: 100vh;
    margin: 0;
  }
  .p-dialog.bulk-cancel-dialog .cancellation-form {
    grid-template-columns: minmax(0, 1fr);
  }
}
@media (max-width: 480px) {
  .p-dialog.bulk-cancel-dialog .bulk-cancel-list-header {
    padding: 0 12px;
  }
  .p-dialog.bulk-cancel-dialog .bulk-cancel-list li label {
    gap: 12px;
    padding: 12px;
  }
  .p-dialog.bulk-cancel-dialog .bulk-cancel-date {
    width: 38px;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
